import getQueryParameter from './getQueryParameter';
import findTopWindow from './findTopWindow';

const getTenant = () => {
  let top = findTopWindow();
  if (!top) return 'vinci_content';

  if ((top as EditorWindow).__AUTHORING_LITE__) {
    // Read the hash from the authoring-lite host window (`top`), not the local
    // `window`: in the preview iframe `window` has no hash, so the tenant would
    // wrongly fall back to 'vinci_content' and the auth-header cookie lookup
    // would miss. `top` is same-origin (findTopWindow only walks same-origin).
    const firmCode = top.location.hash.split('/')[1];
    return firmCode || 'vinci_content';
  }

  const query = getQueryParameter('tenant', top);
  return query || 'vinci_content';
};

export default getTenant;
